import { MmSyncableModel } from '@docma-mm-core/model/mm-syncable.model';
import { GroupTypeEnum } from './group-type.enum';

export class GroupData {

    constructor(init?: Partial<GroupData>) {
        if (init) {
            Object.assign(this, init);
        }
    }

    Id?: number;
    GroupType?: number;
    Description?: string;
    SUid?: string;
    UniqueId?: string;
}

export class Group extends MmSyncableModel<GroupData> {

    downloaded = false;

    constructor(init?: Partial<Group>) {
        super(init);
        if (init) {
            Object.assign(this, init);
            this.downloaded = !!init.downloaded;
        }
    }

    id?: number;
    suid?: string;
    groupType: GroupTypeEnum;
    description?: string;
}
